/** All existing types of {@link Content}. */
export enum ContentType {
  YOUTUBE = 1,
  SCORM = 2,
  PDF = 3,
  EXERCISE = 4,
  MP3 = 5,
  SEARCHFORM = 6
}

/** todo: document this class */
export enum ContentProgressStatus {
  REACH_MIN = 99,
  FINISHED = 100,
}

/** Represents the type YouTube Video of a {@link Content}.
 * This is the entity responsible for holding the video code
 * that generates the video in player as well as further information. */
export class Youtube {
  public code: string;
  public duration: string;
  public thumbnail: string;

  constructor(
    code: string = "",
    duration: string = "",
    thumbnail: string = ""
  ) {
    this.code = code;
    this.duration = duration;
    this.thumbnail = thumbnail;
  }
}

export class Audio {
  public timestamp: number;
  constructor(timestamp = 0) {
    this.timestamp = timestamp;
  }
}

/** Represents the type Scorm of a {@link Content} and holds its files. */
export class Scorm {
  public file: ArrayBuffer | string;
  public url: string;

  constructor(file: ArrayBuffer | string = "", url = "") {
    this.file = file;
    this.url = url;
  }
}

/** Used to set different types of content_provider. */
export type SimpleFile = {
  /** File name. */
  name: string;

  /** SCORM version. */
  scormVersion: "1.1" | "1.2" | "2004.2" | "2004.3";

  /** Folder path of the file. */
  path: string;
};

export type SCORMContent = Map<string, string | Object>;